import {
  create,
} from 'zustand';
import {
  ServiceFacilityDTO,
} from 'dtos';
import {
  getApiOrgConfigurationGetServiceFacilities,
} from 'endpoints';

type Props = {
  serviceFacilities: ServiceFacilityDTO[];
  isLoading: boolean;
  error: Error | null;
  actions: {
    fetchServiceFacilities: () => Promise<void>;
    setServiceFacilities: (facilities: ServiceFacilityDTO[]) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: Error | null) => void;
  };
};

const useServiceFacilityStore = create<Props>((set, get) => ({
  serviceFacilities: [],
  isLoading: false,
  error: null,
  actions: {
    fetchServiceFacilities: async () => {
      const { isLoading } = get();
      if (!isLoading) {
        set({ isLoading: true, error: null });
        try {
          const response = await getApiOrgConfigurationGetServiceFacilities({
            includeStats: false,
          });
          set({
            serviceFacilities: response?.data ?? [],
            isLoading: false,
          });
        } catch (error) {
          set({
            error: error as Error,
            isLoading: false,
          });
        }
      }
    },
    setServiceFacilities: (facilities: ServiceFacilityDTO[]) => set({
      serviceFacilities: facilities,
    }),
    setLoading: (loading: boolean) => set({ isLoading: loading }),
    setError: (error: Error | null) => set({ error }),
  },
}));

export function useServiceFacilities() {
  return useServiceFacilityStore((state: Props) => state.serviceFacilities);
}

export function useServiceFacilityActions() {
  return useServiceFacilityStore((state: Props) => state.actions);
}
